import { FC } from "react";
import { cn } from "@/core/helpers/cn";
import { CheckIcon, CircleCheckIcon } from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";

type Props = {
  name: "checked" | "success";
  text: string;
  className?: string;
  classNameIcon?: string;
  classNameText?: string;
};

const icon: Record<Props["name"], FC<BaseIconProps>> = {
  checked: CheckIcon,
  success: CircleCheckIcon,
};

export default function EstateBadge({
  name,
  text,
  className,
  classNameIcon,
  classNameText,
}: Props) {
  return (
    <div
      className={cn(
        "relative z-1 flex self-start items-center gap-1.5 h-8 p-2.5 bg-dark-900/60 rounded-[0.4375rem]",
        className,
      )}
      style={{ backdropFilter: "blur(5px)" }}
    >
      {icon[name]({ size: 14, className: classNameIcon })}
      <p className={cn("text-11 font-bold line-clamp uppercase leading-none", classNameText)}>
        {text}
      </p>
    </div>
  );
}
